import React, { useRef, useState } from "react";
import "./style.css";
import { Images } from "../../utils/constant";

interface InputFieldProps {
  label?: string;
  name?: string;
  type?: string;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  required?: boolean;
  pattern?: string;
  placeHolder?: string;
}

const Input = ({
  label = "Name",
  name = "input",
  type = "text",
  value,
  onChange,
  required = false,
  pattern,
}: InputFieldProps) => {
  return (
    <div className="mui-form">
      <div className="mui-input-wrapper">
        <input
          className="mui-input"
          placeholder=" "
          data-placeholder="Email"
          required={required}
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          autoCapitalize="off"
          autoSave="off"
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          pattern={pattern}
        />
        <span className="mui-placeholder">{label}</span>
      </div>
    </div>
  );
};

export default Input;

interface TextFieldProps {
  label: string;
  name: string;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  attachFile?: boolean;
}

export const TextInput = ({
  label,
  name,
  value,
  onChange,
  attachFile,
}: TextFieldProps) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    setSelectedFile(file);
    console.log("Selected file:", file);
  };

  return (
    <div className="mui-form">
      <div className="mui-input-wrapper">
        <textarea
          rows={3}
          className="mui-input"
          placeholder=" "
          data-placeholder="Email"
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          autoCapitalize="off"
          autoSave="off"
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          style={{ resize: "none", paddingBottom: "3vw" }}
        />
        <span className="mui-placeholder">{label}</span>
        {attachFile && (
          <>
            <input
              ref={fileInputRef}
              type="file"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <span
              className="attach-file-container"
              onClick={() => fileInputRef.current?.click()}
            >
              <img
                src={Images.attachFile}
                alt="attach file icon"
                className="attach-file-icon"
              />
              <span className="attach-file-text">
                {selectedFile ? selectedFile.name : "Attach File"}
              </span>
            </span>
          </>
        )}
      </div>
    </div>
  );
};
